import _default from "chart.js/dist/plugins/plugin.tooltip";
import animation = _default.defaults.animation;
import {AttributeValue} from "./AttributeValue";
import {PageSection} from "./PageSection";
import {PageStyle} from "./PageStyle";

export class Pages {
    id: number;
    uid: string="";
    name: string="";
    title: string="";
    summary: string="";
    priority: number = 0;
    createDate: number;
    lastUpdate: number;
    type: string;
    language: string;
    active:boolean=false;
    showIndex:boolean=true;
    otherFields: Map<string, any>=new Map<string, any>();
    tags:Array<string>= new Array<string>();
    style: PageStyle= new PageStyle();
    attributeValues: Array<AttributeValue> = new Array<AttributeValue>();
    pageSections: Array<PageSection> = new Array<PageSection>();
}